import { IconButtonStyle } from './style';

const IconButton = ({ icon, ...props }) => {
  return <IconButtonStyle {...props}>{icon}</IconButtonStyle>;
};

export default IconButton;
